{
  "pt": {
    "task_assignment": {
      "actions": {
        "confirm": "Marcar como concluída",
        "create": "Tarefa",
        "reopen": "Reabrir",
        "update": "Editar tarefa"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Funcionário",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignee": "Responsável",
        "assignees": "Responsáveis",
        "created_at": "Criado",
        "due_date": "Prazo",
        "project": "Projeto",
        "published": "Publicado",
        "status": "Estado",
        "task": "Tarefa",
        "unit": "Unidade"
      },
      "labels": {
        "add_assignee": "Adicionar responsável…",
        "add_customers": "Adicionar clientes",
        "already_assigned": "Esta tarefa já foi adicionada a esta unidade.",
        "completed": "Concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "my_tasks": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_assignments": "Ainda não há tarefas.",
        "no_assignments_task": "Ainda não há atribuições para esta tarefa.",
        "no_assignments_unit": "Ainda não há tarefas para esta unidade.",
        "publish_all": "Publicar tudo",
        "publish_customers": "Publicar para os clientes de cada unidade",
        "published": "Publicado",
        "required": "Este campo é obrigatório",
        "select_task": "Selecione uma tarefa",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa.",
        "uploaded_documents": "Documentos carregados"
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "pending": "Pendente"
      },
      "toasts": {
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "uncompleted": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
